import { LoginSettings } from '@anecdotes/api-contracts';
import { Injectable, inject } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LoginSettingsSelectors } from '../../../store/selectors';
import { LoginSettingsActions } from '../../../store/actions';

@Injectable()
export class LoginSettingsFacade {
  private readonly store = inject(Store);

  load(): void {
    this.store.dispatch(LoginSettingsActions.Load());
  }

  getLoginSettings(): Observable<LoginSettings> {
    return this.store.pipe(select(LoginSettingsSelectors.selectLoginSettings));
  }

  toggleIdpValue(idpId: string): void {
    this.store.dispatch(LoginSettingsActions.ToggleIdp({ idpId }));
  }

  toggleEmailLogin(settingId: string): void {
    this.store.dispatch(LoginSettingsActions.ToggleEmailLogin({ settingId: settingId }));
  }

  toggleSupportTeamLogin(): void {
    this.store.dispatch(LoginSettingsActions.ToggleSupportTeamLogin());
  }
}
